export default __webpack_public_path__ + "assets/play-list-4--screen-television-display-player-movies-players-tv-media-video-entertainment.png";